import '../sass/enquiries-form.scss';

(() => {
    const pristineScript = document.querySelector('#ofg-schools-pristine-js');
    const $blocks = document.querySelectorAll('.block.enquiries-form');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $formErrors = $block.querySelector('.enquiries-form__form-errors');
        const $form = $block.querySelector('.enquiries-form__form');
        const $turnstile = $block.querySelector('.enquiries-form__form-turnstile');
        const $turnstileToken = $block.querySelector('.enquiries-form__form-turnstile-token');
        const $enquiryTypeFields = $block.querySelectorAll('[name="enquiry-type"]');
        const $panels = $block.querySelectorAll('[data-enquiry-panel]');
        const $heading = $block.querySelector('.enquiries-form__form-heading');
        const $jobTitle = $block.querySelector('.enquiries-form__job-title');
        const $roleFields = $block.querySelectorAll('[name="enquirer-role"]');

        let turnstileInstance, pristine, formSubmitted = false;
        
        const getSubmittableFields = () => {
            if (!$form) return [];

            return [...$form.querySelectorAll('input, select, textarea')].filter($field => {
                if ($field.disabled || $field.type === 'hidden') return false;
                if ($field.closest('.enquiries-form__tabs')) return false;

                return !$field.closest('[hidden]');
            });
        };

        const validateSubmittableFields = () => pristine.validate(getSubmittableFields());

        const checkIfTurnstileReady = resolve => {
            const interval = setInterval(() => {
                if (!$turnstileToken.value) return;

                resolve(interval);
                clearInterval(interval);
            }, 100);
        };

        const submitForm = () => {
            fetch('/wp-json/ofg-schools/enquiry', {
                method: 'POST',
                body: new FormData($form)
            }).then(async response => {
                const json = await response.json();

                return json;
            }).then(json => {
                if (json.errors) {
                    throw new Error(json.errors.join('<br />'));
                }

                if (json.success) {
                    const { successPage } = $form.dataset;

                    if (successPage) {
                        window.location.href = successPage;
                    }
                }
            }).catch(error => {
                if (error.message) {
                    $formErrors.innerHTML = error.message;
                    $formErrors.classList.add('enquiries-form__form-errors--show');
                }
            }).finally(() => {
                $form.classList.remove('enquiries-form__form--loading');

                if ($turnstile && typeof turnstile !== 'undefined') {
                    turnstile.reset(turnstileInstance);
                }
            });
        };

        const syncJobTitleField = () => {
            if (!$jobTitle) return;

            const $input = $jobTitle.querySelector('input');
            const admissionsActive = $block.querySelector('[name="enquiry-type"]:checked')?.value === 'admissions';
            const professionalSelected = $block.querySelector('[name="enquirer-role"]:checked')?.value === 'professional';
            const show = admissionsActive && professionalSelected;

            if (show) {
                $jobTitle.removeAttribute('hidden');
            } else {
                $jobTitle.setAttribute('hidden', '');
            }

            if ($input) {
                $input.disabled = !show;
            }
        };

        const setActivePanel = activeType => {
            const $activeField = [...$enquiryTypeFields].find($field => $field.value === activeType);

            if ($heading && $activeField?.dataset.enquiryHeading) {
                $heading.textContent = $activeField.dataset.enquiryHeading;
            }

            $panels.forEach($panel => {
                const isActive = $panel.dataset.enquiryPanel === activeType;

                if (isActive) {
                    $panel.removeAttribute('hidden');
                } else {
                    $panel.setAttribute('hidden', '');
                }

                $panel.querySelectorAll('input, select, textarea, button').forEach($field => {
                    $field.disabled = !isActive;
                });
            });

            syncJobTitleField();

            if (pristine) {
                pristine.reset();
                pristine = new Pristine($form);

                if (formSubmitted) {
                    validateSubmittableFields();
                }
            }
        };

        const initEnquiryTypeTabs = () => {
            if (!$enquiryTypeFields.length || !$panels.length) return;

            const $checkedField = $block.querySelector('[name="enquiry-type"]:checked');

            if ($checkedField) {
                setActivePanel($checkedField.value);
            }

            $enquiryTypeFields.forEach($field => {
                $field.addEventListener('change', () => {
                    setActivePanel($field.value);
                });
            });

            $roleFields.forEach($field => {
                $field.addEventListener('change', syncJobTitleField);
            });

            $block.addEventListener('click', e => {
                const $tab = e.target.closest('.enquiries-form__tab');

                if (!$tab || !$block.contains($tab)) return;

                const $field = $tab.querySelector('[name="enquiry-type"]');

                if (!$field) return;

                $field.checked = true;
                setActivePanel($field.value);
            });
        };

        const initForm = () => {
            if (!$form) return;

            pristine = new Pristine($form);
            
            $form.addEventListener('submit', e => {
                e.preventDefault();

                formSubmitted = true;

                $form.classList.add('enquiries-form__form--loading');
                $formErrors.classList.remove('enquiries-form__form-errors--show');

                if (!validateSubmittableFields()) {
                    $form.classList.remove('enquiries-form__form--loading');

                    return;
                }

                if ($turnstile) {
                    const waitUntilReady = new Promise(checkIfTurnstileReady);

                    waitUntilReady.then(() => {
                        if (!validateSubmittableFields()) {
                            $form.classList.remove('enquiries-form__form--loading');

                            return;
                        }
                        
                        submitForm();
                    });
                } else {
                    submitForm();
                }
            });
        };

        window.onloadTurnstileCallback = () => {
            if (!$turnstile) return;

            turnstileInstance = turnstile.render($turnstile, {
                sitekey: $turnstile?.dataset?.sitekey,
                callback: id => {
                    $turnstileToken.value = id;
                }
            });
        };

        initEnquiryTypeTabs();

        if (typeof Pristine !== 'undefined') {
            initForm();
        } else if (pristineScript) {
            pristineScript.addEventListener('load', () => {
                initForm();
            });
        } else {
            window.addEventListener('load', () => {
                const pristineScript = document.querySelector('#ofg-schools-swiper-js');

                if (!pristineScript) return;

                initForm();
            });
        }
    });
})();
